import React from 'react'
import PropTypes from 'prop-types'

import { constants, ParagraphPrimary, ParagraphTertiary } from 'mage-deps/@klarna/bubble-ui'
import { withStyleSheetOverride } from '@klarna/higher-order-components'
import { Message } from 'mage-i18n'
import { TransitionMotion, spring, presets } from 'react-motion'
const { Colors } = constants

function getDefaultStyleSheet () {
  return {
    alert: {
      opacity: 0,
      border: `1px solid ${Colors.ERROR}`,
      padding: 10,
      marginTop: 20,
      borderRadius: 2
    }
  }
}

const itemStyles = (show) => {
  if (!show) {
    return []
  }

  return [{
    key: 'alert',
    style: {
      opacity: spring(1, presets.gentle),
      scale: spring(1, presets.gentle)
    }
  }]
}

const willEnter = () => ({
  opacity: 0.1,
  scale: 0.5
})

const willLeave = () => ({
  opacity: 0,
  scale: 0
})

export function Alert ({ correlationId, styleSheet }) {
  return (
    <TransitionMotion
      styles={itemStyles(!!correlationId)}
      willEnter={willEnter}
      willLeave={willLeave}
    >
      {items => (
        <div>
          {items.map(({ key, style: { opacity, scale } }) => {
            return (
              <div
                key={key} style={{
                  ...styleSheet.alert,
                  opacity,
                  transform: `scale(${scale})`
                }}
              >
                <ParagraphPrimary error centered>
                  <Message path='core.alert.message' />
                </ParagraphPrimary>
                <ParagraphTertiary error centered>
                  <span style={{ whiteSpace: 'nowrap' }}>
                    <Message path='core.alert.correlationIdLabel' />
                    <span style={{ marginLeft: 5 }}>
                      {correlationId}
                    </span>
                  </span>
                </ParagraphTertiary>
              </div>
            )
          })}
        </div>
      )}
    </TransitionMotion>
  )
}

Alert.propTypes = {
  correlationId: PropTypes.string,
  styleSheet: PropTypes.shape({
    alert: PropTypes.object
  })
}

export default withStyleSheetOverride(
  getDefaultStyleSheet
)(Alert)
